import React from 'react';
import {
  TextField,
  Datagrid,
  ReferenceManyField,
  SimpleShowLayout,
  Pagination,
  FunctionField,
  useResourceContext,
} from 'react-admin';
import LinkField from 'components/LinkField';
import { DisplayHelpers } from 'utils/helpers';

const RESOURCE_TARGET_MAP: Record<string, string> = {
  Company: 'irm_for_company_id',
  Location: 'irm_for_location_id',
};

export const IRMProfessionalsTab = () => {
  const resource = useResourceContext();

  const target = RESOURCE_TARGET_MAP[resource];
  if (!target) {
    console.warn(`IRMProfessionalsTab used in unsupported resource: ${resource}`);
    return null;
  }

  return (
    <SimpleShowLayout>
      <ReferenceManyField
        label={false}
        reference="Professional"
        pagination={<Pagination />}
        target={target}
      >
        <Datagrid bulkActionButtons={false}>
          <LinkField label="ID" source="id" />
          <TextField label="Name" source="account.name" />
          <FunctionField
            label="Positions"
            source="positions"
            render={DisplayHelpers.professional.positionNames}
            data-testid="professional_show-kinds_field"
          />
          <TextField label="Status" source="status" />
        </Datagrid>
      </ReferenceManyField>
    </SimpleShowLayout>
  );
};
